import { useRef, useCallback } from "react";
import { getColorForSpeed } from "@/utils/congestionColors";

/**
 * Manages congestion-colored polyline overlays on the route.
 * Draws colored segments from LinkSpeed data returned by the route API.
 * Each LinkSpeed has coordinates (array of {lat, lng}) and speedInMetersPerSecond.
 */
const useTrafficOverlay = (map) => {
  const polylinesRef = useRef([]);

  const clearOverlay = useCallback(() => {
    polylinesRef.current.forEach((p) => p.setMap(null));
    polylinesRef.current = [];
  }, []);

  const showTrafficOverlay = useCallback(
    (linkSpeeds) => {
      clearOverlay();
      if (!map || !linkSpeeds?.length) return;

      for (const link of linkSpeeds) {
        if (!link.c?.length || link.c.length < 2) continue;

        const color = getColorForSpeed(link.s);
        const path = link.c.map((pt) => ({ lat: pt.lat, lng: pt.lng }));

        const polyline = new window.google.maps.Polyline({
          path,
          strokeColor: color,
          strokeOpacity: 0.85,
          strokeWeight: 6,
          zIndex: 1,
        });
        polyline.setMap(map);
        polylinesRef.current.push(polyline);
      }
    },
    [map, clearOverlay],
  );

  return { showTrafficOverlay, clearOverlay };
};

export default useTrafficOverlay;
